export default __webpack_public_path__ + "static/media/CNo.88-1.ba0b8a1c.jpg";